import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ZoomSliceType = {
  scale: number
}

const INITIAL_STATE: ZoomSliceType = {
  scale: 1,
}

/**
 * 캔버스 휠, +/- 버튼, 셀렉트로 줌 sync를 맞추기위한 slice
 * */
export const zoomSlice = createSlice({
  name: 'zoom',
  initialState: INITIAL_STATE,
  reducers: {
    setZoomScale(state, action: PayloadAction<number>) {
      state.scale = action.payload
    },
  },
})

export const { setZoomScale } = zoomSlice.actions

export default zoomSlice.reducer
